import omit from '../_util/omit';
import { eventType, objectType } from '../_util/type';
import { inputProps as vcInputProps } from '../vc-input/inputProps';
export const inputDefaultValue = Symbol();
const inputProps = () => {
    return Object.assign(Object.assign({}, omit(vcInputProps(), [
        'wrapperClassName',
        'groupClassName',
        'inputClassName',
        'affixWrapperClassName',
        'affixWrapperStyle',
        'inputStyle',
        'prefixClassName',
        'prefixStyle',
        'suffixClassName',
        'suffixStyle',
    ])), { 
        /** Semantic structure className (antd ≥ 5.4). */
        classNames: objectType(), 
        /** Semantic structure style (antd ≥ 5.4). */
        styles: objectType() });
};
export default inputProps;
const textAreaProps = () => (Object.assign(Object.assign({}, omit(inputProps(), ['prefix', 'addonBefore', 'addonAfter', 'suffix'])), { rows: Number, autosize: { type: [Boolean, Object], default: undefined }, autoSize: { type: [Boolean, Object], default: undefined }, onResize: { type: Function }, onCompositionstart: eventType(), onCompositionend: eventType(), valueModifiers: Object, 
    /** Semantic structure className (antd ≥ 5.4). */
    classNames: objectType(), 
    /** Semantic structure style (antd ≥ 5.4). */
    styles: objectType() }));
export { textAreaProps };
